const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

function toDate(value) {
  if (value instanceof Date) return value;
  if (typeof value?.toDate === "function") return value.toDate();
  if (typeof value?.seconds === "number") return new Date(value.seconds * 1000);
  return null;
}

function formatDateRange(start, end) {
  if (!start || !end) return null;

  const formatter = new Intl.DateTimeFormat("en-CA", {
    month: "short",
    day: "numeric",
    timeZone: "America/Toronto",
  });
  return `${formatter.format(start)} – ${formatter.format(end)}`;
}

export function getPhotoPeriodLabel(periodStart, periodEnd) {
  const label = formatDateRange(toDate(periodStart), toDate(periodEnd));
  return label || "This week's community favourites";
}

export function getLeaderboardWeekLabel(periodEnd) {
  const start = toDate(periodEnd);
  if (!start) return "This week's leaderboard";

  return formatDateRange(start, new Date(start.getTime() + WEEK_MS));
}
